import { SEO as FP_GOLD_SEO } from './Seo_fpgold.js';
export var SEO = function () {
    return FP_GOLD_SEO;
};



// WEBPACK FOOTER //
// ./src/SEO/getSeoByDomen.js